import { render, staticRenderFns } from "./SamModal.vue?vue&type=template&id=58663346&scoped=true&"
import script from "./SamModal.vue?vue&type=script&lang=js&"
export * from "./SamModal.vue?vue&type=script&lang=js&"
import style0 from "./SamModal.vue?vue&type=style&index=0&id=58663346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58663346",
  null
  
)

export default component.exports